import { useTranslation } from '@testsigma/atoms';

export const SpoofingBanner = ({ isSpoofing }) => {
  const { t } = useTranslation();

  return (
    isSpoofing && (
      <div className='w-full text-error-500 relative flex flex-row items-center justify-center'>
        <span>{t('user.spoofing_banner')}</span>
      </div>
    )
  );
};
